import { parseDataAttributes } from '../../utilities/utilities'
import type { TypographyConfig, ButtonConfig } from '../../types/widget-types'

export type AuthenticationConfigStyles = {
  labelTypography?: TypographyConfig
  loginButtonVariant?: ButtonConfig
  requestResetBackToLoginButtonVariant?: ButtonConfig
  forgotPasswordButtonVariant?: ButtonConfig
}

export type AuthenticationAttributes = {
  configStyles?: AuthenticationConfigStyles
}

export function getAuthenticationAttributes(attrs: NamedNodeMap): AuthenticationAttributes {
  const base = parseDataAttributes(attrs) as Record<string, unknown>

  return {
    configStyles: base.configStyles as AuthenticationConfigStyles | undefined,
  }
}

export default function propsFn(dataAttributes: NamedNodeMap): AuthenticationAttributes {
  return getAuthenticationAttributes(dataAttributes)
}
